"use client"

export function Button({
  children,
  variant = "default",
  size = "default",
  className = "",
  onClick,
  disabled = false,
  type = "button",
}) {
  const baseStyles = "font-medium rounded-lg transition-colors"

  const variantStyles = {
    default: `bg-[#7B189F] hover:bg-[#671485] text-white`,
    outline: "border border-gray-200 hover:bg-gray-50 text-gray-700",
  }

  const sizeStyles = {
    default: "px-4 py-2",
    sm: "px-3 py-1 text-sm",
  }

  const styles = `${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${className} ${disabled ? "opacity-50 cursor-not-allowed" : ""}`

  return (
    <button type={type} className={styles} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  )
}
